<template>
<div class='fw-file-upload'
     :class='`fw-file-upload--${type}`'>
    <div class='fw-file-icon'>
        <div class='h-inline-flex h-flex-space-between h-width-100p h-pos-rel'>
            <div
                class='fw-file-img h-width-150 h-flex-center h-pl-10px'
                :style='{"minHeight": minHeight}'>
                <img v-if='currentImage' class='h-width-100p h-m-20' :src='currentImage'>
                <p v-else>
                    {{ noImageText }}
                </p>
            </div>
            <input ref='fileInput'
                   style='display: none'
                   type='file'
                   @change='onFileSelected'>
            <div class='fw-file-upload__icons_wrapper'>
                <div class='h-pointer' @click='$refs.fileInput.click()'>
                    <FwIcon class='h-flex'
                            :icon='uploadIcon'
                            :size='sizeIcon'
                            :color='colorIcon'>
                    </FwIcon>
                </div>
                <div class='h-mt-15 h-pointer' @click='removeImage'>
                    <FwIcon class='h-flex'
                            :icon='deleteIcon'
                            :size='sizeIcon'
                            :color='colorIcon'>
                    </FwIcon>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang='ts'>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

const AVAILABLE_TYPES: Array<string> = ['base', 'rectangle'];

@Component
export default class FwFileUpload extends Vue {
    @Prop({ type: String, default: '' }) readonly uploadIcon!: string;
    @Prop({ type: String, default: '' }) readonly deleteIcon!: string;
    @Prop({ type: String, default: '' }) readonly colorIcon!: string;
    @Prop({ type: String, default: '' }) readonly sizeIcon!: string | number;
    @Prop({ type: String, default: '' }) readonly imgUrl!: string;
    @Prop({ type: String, default: 'auto' }) readonly minHeight!: string;
    @Prop({ type: String, default: 'image.*' }) readonly format!: string;
    @Prop({ type: String, default: 'No image' }) readonly noImageText!: string;
    @Prop({ type: Number, default: null }) readonly maxLimit!: number;
    @Prop({ type: String, default: 'base', validator: (size: string) => AVAILABLE_TYPES.includes(size) }) readonly type!: string;

    currentImage: string = this.imgUrl;

    onFileSelected(event: any) {
        const file = event.target.files;
        this.onUpload(file[0]);
    }

    onUpload(file: File) {
        if (!file.type.match(this.format)) {
            this.currentImage = '';
            this.$emit('wrongFormat');
            return;
        } else if (this.maxLimit && file.size > this.maxLimit) {
            this.$emit('maxLimit');
            return;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
            this.currentImage = e.target.result;
            this.$emit('uploadCurrentImage', this.currentImage);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    }

    removeImage() {
        this.currentImage = '';
        this.$emit('removeImage');
    }
};
</script>

<style lang='sass'>
.fw-file-img
    border-radius: 10px
    border: none
    background-color: #FFFFFF

.fw-file-upload
    &--rectangle
        width: 100%

        .fw-file-img
            width: 100%

        .fw-file-upload__icons_wrapper
            flex-direction: row
            position: absolute
            right: 0
            top: -50px
            align-items: baseline

            & > *:not(:last-of-type)
                margin-right: 10px

    &__icons_wrapper
        flex-direction: column
        display: flex
        align-items: center
        justify-content: center
</style>
